const getMatchedStringArray = (str, regex) => {
  const result = [];
  let match = regex.exec(str);
  while (match !== null) {
    result.push(match[1]);
    match = regex.exec(str);
  }
  return result;
};

export { getMatchedStringArray as default };
//# sourceMappingURL=getMatchedStringArray.mjs.map
